import * as React from "react";
import {
  TextInput,
  Button,
  Grid,
  Title,
  Card,
  Text,
  useMantineTheme,
} from "@mantine/core";
import { Link, useSearchParams } from "react-router-dom";

import { RoleType } from "@supportinitiative/common";

import { escapeRegExp } from "../utilities";
import { useRoles } from "../hooks";
import Loading from "../ui/Loading";
import { styles } from "../styles";

function getIsMatch(filter: string) {
  const isMatch = (role: RoleType) => {
    const re = new RegExp(escapeRegExp(filter), "i");
    return re.test(role.name) || re.test(role.description);
  };
  return isMatch;
}

export default function Roles() {
  let [searchParams] = useSearchParams();
  let entityId = searchParams.get("entityId");

  let [filter, setFilter] = React.useState("");
  const { data: roles, isLoading } = useRoles(entityId);
  let [filteredRoles, setFilteredRoles] = React.useState<RoleType[]>([]);
  const theme = useMantineTheme();

  React.useEffect(() => {
    if (roles) {
      let filteredValues = roles.filter(getIsMatch(filter));
      setFilteredRoles(filteredValues);
    }
  }, [roles, filter]);

  return (
    <div style={{ marginTop: theme.spacing.lg }}>
      <Title order={3}>Roles</Title>
      <Grid align="center" gutter={"xs"} mb="xs">
        <Grid.Col span={3}>
          <TextInput
            placeholder="Search"
            onChange={(event) => {
              setFilter(event.target.value);
              let filteredValues = roles.filter(getIsMatch(event.target.value));
              setFilteredRoles(filteredValues);
            }}
          />
        </Grid.Col>
        <Grid.Col span={1}>
          <Button
            color="teal"
            styles={() => ({
              root: {
                // margin: "5px",
              },
            })}
            aria-label="New"
            fullWidth
            component={Link}
            to={`/app/roles/new?entityId=${entityId}`}
          >
            New
          </Button>
        </Grid.Col>
      </Grid>

      {isLoading ? (
        <Grid align="center" gutter={"xs"} mb="xs" mt="lg">
          <Grid.Col span={3}>
            <Loading />
          </Grid.Col>
        </Grid>
      ) : (
        <>
          {filteredRoles.length > 0 ? (
            <Grid align="center" gutter={"xs"} mb="xs">
              {filteredRoles.map((role) => {
                return (
                  <Grid.Col span={3} key={role.id as unknown as string}>
                    <Card
                      component={Link}
                      to={`/app/roles/edit?id=${role.id}&entityId=${entityId}`}
                      shadow="sm"
                      p="xs"
                      data-testid="role"
                    >
                      <Text fw={500}>{role.name}</Text>
                      <Text
                        size="sm"
                        style={{
                          color: theme.colors.gray[7],
                          lineHeight: 1.5,
                        }}
                      >
                        {role.description}
                      </Text>
                    </Card>
                  </Grid.Col>
                );
              })}
            </Grid>
          ) : (
            <div
              style={{
                display: "flex",
                flexDirection: "column",
                marginTop: theme.spacing.lg,
              }}
            >
              <Text fw={500} style={styles.nodata} data-testid="nodata">
                No Roles
              </Text>
            </div>
          )}
        </>
      )}
    </div>
  );
}
